import { memo } from "react";
import { Gavel, Clock, Flame } from "lucide-react";
import MoneyIcon from "@/components/MoneyIcon";
import type { AuctionItem } from "@/types/auction";

interface MobileStatsRowProps {
  auctions: AuctionItem[];
  filteredCount: number;
  totalValue: number;
}

const formatValue = (value: number): string => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return value.toLocaleString('de-DE');
};

const MobileStatsRow = memo(({ auctions, filteredCount, totalValue }: MobileStatsRowProps) => {
  // Calculate ending soon (within 1 hour)
  const endingSoon = auctions.filter(a => {
    const timeLeft = new Date(a.endTime).getTime() - Date.now();
    return timeLeft > 0 && timeLeft < 3600000;
  }).length;

  return (
    <div className="px-4 py-2 overflow-x-auto">
      <div className="flex gap-2 min-w-max">
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-card border border-border/50">
          <Gavel size={14} className="text-muted-foreground shrink-0" />
          <span className="text-xs text-muted-foreground">Aktiv</span>
          <span className="text-sm font-bold text-foreground">{filteredCount}</span>
        </div>
        
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-card border border-border/50">
          <MoneyIcon size={14} className="shrink-0" />
          <span className="text-xs text-muted-foreground">Wert</span>
          <span className="text-sm font-bold text-foreground">{formatValue(totalValue)}</span>
        </div>
        
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-card border border-border/50">
          <Clock size={14} className="text-chart-5 shrink-0" />
          <span className="text-xs text-muted-foreground">Bald</span>
          <span className="text-sm font-bold text-foreground">{endingSoon}</span>
        </div>
      </div>
    </div>
  );
});

MobileStatsRow.displayName = 'MobileStatsRow';

export default MobileStatsRow;
